import axios from 'axios';
import { store } from '../redux/store';


export const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
});

export const fetchApi = async (apiCall, method = 'get', data = null, isOpen = false, newServer = false, cancelToken = null) => {
    const headers = getWebHeadersJson(isOpen, newServer);

    Object.entries(headers).forEach(([key, value]) => {
        axiosInstance.defaults.headers.common[key] = value;
    });

    const headersToDelete = getHeadersToDelete(isOpen, newServer);
    headersToDelete.forEach(headerKey => {
        delete axiosInstance.defaults.headers.common[headerKey];
    });

    const api = getUrl(apiCall, isOpen ,newServer);
    const options = {
        method,
        url: api,
        cancelToken: cancelToken ? cancelToken.token : null
    };
    if (data) {
        if (method === 'get') {
            options.params = data;
        } else {
            options.data = data;
        }
    }
    try {
        const response = await axiosInstance.request(options);
        return response.data;
    } catch (err) {
        throw err.response.data;
    }
};


 const getUrl = (apiCall , isOpen ,newServer) => {
    if(isOpen){
        return newServer ? `${process.env.REACT_APP_NEW_API_URL_OPEN}${apiCall}?XDEBUG_SESSION_START=PHPSTORM` : `${process.env.REACT_APP_API_URL}${apiCall}`;
    }
    else if(newServer) {
        return `${process.env.REACT_APP_NEW_API_URL}${apiCall}?XDEBUG_SESSION_START=PHPSTORM`;
    }
    else{
        return `${process.env.REACT_APP_API_URL}${apiCall}?XDEBUG_SESSION_START=PHPSTORM`;
    }

}

export const fetchApiStream = async (
    apiCall,
    method = 'get',
    data = null,
    isOpen = false,
    newServer = false,
    cancelToken = null,
    onChunk = null // Callback for each chunk
) => {
     
    if (newServer && !isOpen) {
        axiosInstance.defaults.headers.common.token = store.getState().auth?.data?.token;
    } else {
        delete axiosInstance.defaults.headers.common.token;
        delete axiosInstance.defaults.headers.common.manage;
    }
    axiosInstance.defaults.headers.common.lang = store.getState().userSettings?.lang?.language === 'Hebrew' ? 'he' : 'en';
    if (newServer) {
        const isAccessControl = store.getState().accessControl.isAccessControl
        const isCheckIn = store.getState().rootManager.isCheckIn
        axiosInstance.defaults.headers.common.manage = isAccessControl ? 'ac' : isCheckIn ? 'checkin' : 'system';
    }

    const api = getUrl(apiCall, isOpen, newServer);

    const headers = {
        'Content-Type': 'application/json',
        ...axiosInstance.defaults.headers.common
    };

    const response = await fetch(api, {
        method: method.toUpperCase(),
        headers,
        body: data ? JSON.stringify(data) : null,
        signal: cancelToken?.signal
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        if (onChunk) {
            onChunk(chunk);
        }
    }
};

export const getWebHeadersJson = (isOpen = false, newServer = false) => {
    let headers = {}
    if (newServer && !isOpen) {
        headers.token = store.getState().auth?.data?.token;
    }
    headers.lang = store.getState().userSettings?.lang?.language === 'Hebrew' ? 'he' : 'en';
    if (newServer) {
        const isAccessControl = store.getState().accessControl.isAccessControl
        const isCheckIn = store.getState().rootManager.isCheckIn
        headers.manage = isAccessControl ? 'ac' : isCheckIn ? 'checkin' : 'system';
        const activeLocationId = store.getState().userSettings?.scheduleLocation?.id;
        if (!isOpen && activeLocationId) {
            headers['X-Locations-Box-Id'] = activeLocationId;
        }
    }
    headers.isArgaz = !!store.getState().auth?.data?.originalUser;

    return headers
}

const getHeadersToDelete = (isOpen = false, newServer = false) => {
    const headersToDelete = [];

    if (!newServer || isOpen) {
        headersToDelete.push('token', 'manage');
    }
    const activeLocationId = store.getState().userSettings?.scheduleLocation?.id;
    if (!newServer || isOpen || !activeLocationId) {
        headersToDelete.push('X-Locations-Box-Id');
    }

    return headersToDelete;
}
